export type WorksheetExecutionProfile =
  | 'creatorInteractive'
  | 'dashboardTile'
  | 'spreadsheetEmbedded'

export type WorksheetRuntimeCapabilities = {
  platform: 'web' | 'electron'
  browserOnlyExecution: boolean
  supportsLocalDatasetCacheWrites: boolean
  supportsIpcDirectResults: boolean
  supportsConcurrentBackgroundSql: boolean
  preferredPagingProfile: 'browser' | 'desktop'
}

export const resolveWorksheetRuntimeCapabilities = (input?: Partial<WorksheetRuntimeCapabilities>): WorksheetRuntimeCapabilities => {
  const platform = input?.platform === 'electron' ? 'electron' : 'web'
  return {
    platform,
    browserOnlyExecution: input?.browserOnlyExecution ?? true,
    supportsLocalDatasetCacheWrites: input?.supportsLocalDatasetCacheWrites ?? true,
    supportsIpcDirectResults: input?.supportsIpcDirectResults ?? (platform === 'electron'),
    supportsConcurrentBackgroundSql: input?.supportsConcurrentBackgroundSql ?? (platform === 'electron'),
    preferredPagingProfile: input?.preferredPagingProfile ?? (platform === 'electron' ? 'desktop' : 'browser'),
  }
}
